<script setup>
import { SOCIAL_SHARE_IMAGE, usePageHead } from '@composables/use-page-head'
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import Layout from '@layouts/main-layout'
import PlaylistsGridBlock from '@components/playlists/playlists-grid-block'

const playlists = ref([])
const featuredPlaylists = ref([])

// The "Made for You" section is on hold (FWEB101): its endpoint,
// playlists.getMemberRecommendations, is commented out in the data layer. Declared so the
// template reference resolves and the section stays hidden until it comes back.
const recommendedPlaylists = ref([])

// A playlist with no published revision has no cover art and no tracklist to show.
const isPublished = playlist =>
    playlist.revisions_id !== null &&
    playlist.revisions_album_art &&
    playlist.revisions_album_art.filename

onMounted(() => {
    DataLayer.playlists.getByType({ type: 'editorial' }).then(res => {
        res.body.filter(isPublished).forEach(playlist => {
            if (playlist.featured === 1) {
                featuredPlaylists.value.push(playlist)
            } else {
                playlists.value.push(playlist)
            }
        })
    })
})

usePageHead({
    title: 'Playlists',
    description: 'Curated playlists across house, techno, progressive, and more on FRISKY.',
    image: SOCIAL_SHARE_IMAGE,
})
</script>

<template>
    <Layout>
        <BaseContent title="Playlists">
            <BaseSection
                v-if="featuredPlaylists && featuredPlaylists.length"
                title="Featured Playlists"
                padded
            >
                <PlaylistsGridBlock
                    :playlists="featuredPlaylists"
                    type="playlists"
                />
            </BaseSection>
            <BaseSection
                v-if="recommendedPlaylists && recommendedPlaylists.length"
                title="Made for You"
                padded
            >
                <PlaylistsGridBlock
                    :playlists="recommendedPlaylists"
                    type="playlists"
                />
            </BaseSection>
            <BaseSection padded>
                <PlaylistsGridBlock
                    :playlists="playlists"
                    type="playlists"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>
